// // import { Injectable, inject } from '@angular/core';
// // import { Observable, tap, catchError, of, map } from 'rxjs';
// // import { Api } from './api';
// // import { Token } from './token';

// // export interface LoginResponse {
// //   token: string;
// // }

// // @Injectable({ providedIn: 'root' })
// // export class AuthService {

// //   private api = inject(Api);
// //   private tokenService = inject(Token);

// //   login(data: { email: string; password: string }): Observable<LoginResponse> {
// //     return this.api
// //       .post<LoginResponse>('v1', 'login', data)
// //       .pipe(
// //       tap(res => {
// //   console.log('LOGIN RESPONSE:', res);
// //   this.tokenService.set(res.token);
// //   console.log('Saved token:', sessionStorage.getItem('token'));
// // })
// //       );
// //   }

// //   autoToken(): Observable<LoginResponse> {
// //     return this.api.get<LoginResponse>('v1', 'auto-token');
// //   }

// //   // ✅ NEW: Restore session safely
// // restoreSession(): Observable<boolean> {
// //   if (this.isAuthenticated()) {
// //     return of(true);
// //   }

// //   return this.autoToken().pipe(
// //     tap(res => {
// //       if (res?.token) {
// //         this.tokenService.set(res.token);
// //       }
// //     }),
// //     map(res => !!res?.token),   // ✅ convert to boolean
// //     catchError(() => of(false))
// //   );
// // }

// //   isAuthenticated(): boolean {
// //     return this.tokenService.isLoggedIn();
// //   }

// //   logout(): void {
// //     this.tokenService.clear();
// //   }
// // }

// import { Injectable, inject } from '@angular/core';
// import { Observable, tap, catchError, of, map } from 'rxjs';
// import { Api } from './api';
// import { Token } from './token';
// import { DomainService } from './domain';

// export interface LoginResponse {
//   token: string;
// }

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthService {

//   private api = inject(Api);
//   private tokenService = inject(Token);
//   private domainService = inject(DomainService);

//   login(data: { email: string; password: string }): Observable<LoginResponse> {
//     return this.api.post<LoginResponse>('v1', 'login', data).pipe(
//       tap(res => {
//         if (res?.token) {
//           this.tokenService.setToken(res.token);
//         }
//       })
//     );
//   }

//   autoToken(): Observable<LoginResponse> {
//     return this.api.get<LoginResponse>('v1', 'auto-token');
//   }

//   // restoreSession(): Observable<boolean> {

//   //   if (this.tokenService.isLoggedIn()) {
//   //     return of(true);
//   //   }

//   //   return this.autoToken().pipe(
//   //     tap(res => {
//   //       if (res?.token) {
//   //         this.tokenService.setToken(res.token);
//   //       }
//   //     }),
//   //     map(res => !!res?.token),
//   //     catchError(() => of(false))
//   //   );
//   // }
// // In AuthService
// restoreSession(): Observable<boolean> {
//   if (this.tokenService.isLoggedIn()) return of(true);

//   // wait for domain API if needed
//   return this.domainService.getDomainDetails({ Route: 'adms_form', Domain: window.location.host })
//     .pipe(
//       map(res => !!res?.Token),
//       catchError(() => of(false))
//     );
// }
//   logout(): void {
//     this.tokenService.clearToken();
//   }

//   isAuthenticated(): boolean {
//     return this.tokenService.isLoggedIn();
//   }
// }


// import { Injectable, inject } from '@angular/core';
// import { Observable, of, tap, map, catchError } from 'rxjs';
// import { Api } from './api';
// import { Token } from './token';

// @Injectable({ providedIn: 'root' })
// export class AuthService {
//   private api = inject(Api);
//   private tokenService = inject(Token);

//   // Check if token exists in sessionStorage
//   isAuthenticated(): boolean {
//     return this.tokenService.isLoggedIn();
//   }

//   // Restore session for current tab
//   restoreSession(): Observable<boolean> {
//     if (this.tokenService.isLoggedIn()) return of(true);
//     return of(false); // token will be set via DomainService in AdminLayout
//   }

//   logout(): void {
//     this.tokenService.clearToken();
//   }
// }


import { Injectable, inject } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { Token } from './token';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenService = inject(Token);

  // Observable to track token readiness
  private tokenReady$ = new BehaviorSubject<boolean>(this.tokenService.isLoggedIn());

  setTokenFromDomain(token: string) {
    this.tokenService.setToken(token);
    this.tokenReady$.next(true); // signal that token is ready
  }

  // Observable that emits true when token is ready
  waitForToken(): Observable<boolean> {
    return this.tokenReady$.asObservable();
  }

  isAuthenticated(): boolean {
    return this.tokenService.isLoggedIn();
  }

  logout(): void {
    this.tokenService.clearToken();
    this.tokenReady$.next(false);
  }
}
